import { useState } from "react";
import Smartphone from "../../../assets/DeviceWorld1.jpg"
import Laptop from "../../../assets/DeviceWorld2.jpg"
import Headset from "../../../assets/DeviceWorld3.jpg"
import Speaker from "../../../assets/DeviceWorld4.jpg"
import Charger from "../../../assets/DeviceWorld5.jpg"
import Case from "../../../assets/DeviceWorld6.jpg"

const devices = [
  {
    id: "smartphone",
    label: "Smartphone",
    blurb: "Flagship phones and everyday mobiles — checked and ready.",
    image: Smartphone
  },
  {
    id: "laptop",
    label: "Laptop",
    blurb: "Slim ultrabooks and dependable computing for work and study.",
    image: Laptop
  },
  {
    id: "headset",
    label: "Headset",
    blurb: "Immersive wireless audio with plush comfort for all day.",
    image: Headset
  },
  {
    id: "speaker",
    label: "Speaker",
    blurb: "Compact Bluetooth sound that fills the room.",
    image: Speaker
  },
  {
    id: "charger",
    label: "Charger",
    blurb: "Fast, compact charging for your phone and laptop.",
    image: Charger
  },
  {
    id: "case",
    label: "Phone Case",
    blurb: "Protection and style for every phone you carry.",
    image: Case
  },
];

export default function DeviceWorld() {
  const [active, setActive] = useState(0);
  const current = devices[active];

  return (
    <section id="world" className="bg-foreground-950 py-20 md:py-28">
      <div className="container-x">
        <div className="mb-10 flex flex-col gap-6 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="eyebrow-light mb-4 flex items-center gap-3">
              <span className="inline-block h-px w-8 bg-primary-500"></span>
              The Range
            </p>
            <h2 className="section-title-light">Explore the World of Tech.</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-100/70 md:text-right">
            One device, one experience. Select a category to bring it into focus.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1fr_300px]">
          {/* Stage */}
          <div className="relative overflow-hidden rounded-xl border border-foreground-800 bg-foreground-900">
            <div className="aspect-[4/3] md:aspect-[16/9]">
              <img
                src={current.image}
                alt={current.blurb}
                loading="lazy"
                className="h-full w-full object-cover object-center"
                style={{ animation: "deviceIn .8s ease-out" }}
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 bg-gradient-to-t from-foreground-950/90 to-transparent p-4 md:p-8">
              <div>
                <p className="font-heading text-xl text-background-50 md:text-3xl">{current.label}</p>
                <p className="mt-1 max-w-md text-sm text-background-100/70">{current.blurb}</p>
              </div>
              <a href="#products" className="btn-primary hidden shrink-0 sm:inline-flex h-11 px-5 text-xs">
                Browse <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <style>{`@keyframes deviceIn{from{opacity:0;transform:scale(1.04)}to{opacity:1;transform:scale(1)}}`}</style>
          </div>

          {/* Selector */}
          <div className="grid grid-cols-3 gap-2 lg:flex lg:flex-col lg:flex-nowrap">
            {devices.map((d, i) => (
              <button
                key={d.id}
                onClick={() => setActive(i)}
                className={`group flex cursor-pointer items-center justify-between rounded-md border px-3 py-2.5 text-left transition-all duration-300 lg:px-4 lg:py-3.5 ${active === i
                    ? "border-primary-500 bg-primary-500/10"
                    : "border-foreground-800 hover:border-foreground-600"
                  }`}
              >
                <span
                  className={`flex-1 min-w-0 truncate font-label text-[11px] lg:text-xs ${active === i ? "text-primary-400" : "text-background-100/70"
                    }`}
                >
                  {d.label}
                </span>
                <i
                  className={`shrink-0 ri-arrow-right-line transition-all ${active === i ? "text-primary-400" : "text-background-50/30 group-hover:translate-x-1"
                    }`}
                ></i>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}